"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrills = void 0;
var useDrill_1 = require("../hooks/useDrill");
var useDrillDown_1 = require("../hooks/useDrillDown");
var useDrillToInsight_1 = require("../hooks/useDrillToInsight");
var useDrillToDashboard_1 = require("../hooks/useDrillToDashboard");
var useDrillToAttributeUrl_1 = require("../hooks/useDrillToAttributeUrl");
var useDrillToCustomUrl_1 = require("../hooks/useDrillToCustomUrl");
var useDrillToLegacyDashboard_1 = require("./useDrillToLegacyDashboard");
/**
 * @internal
 */
function useDrills(_a) {
    var onDrill = _a.onDrill, onDrillSuccess = _a.onDrillSuccess, onDrillError = _a.onDrillError, 
    //
    onDrillDown = _a.onDrillDown, onDrillDownSuccess = _a.onDrillDownSuccess, onDrillDownError = _a.onDrillDownError, 
    //
    onDrillToInsight = _a.onDrillToInsight, onDrillToInsightSuccess = _a.onDrillToInsightSuccess, onDrillToInsightError = _a.onDrillToInsightError, 
    //
    onDrillToDashboard = _a.onDrillToDashboard, onDrillToDashboardSuccess = _a.onDrillToDashboardSuccess, onDrillToDashboardError = _a.onDrillToDashboardError, 
    //
    onDrillToAttributeUrl = _a.onDrillToAttributeUrl, onDrillToAttributeUrlSuccess = _a.onDrillToAttributeUrlSuccess, onDrillToAttributeUrlError = _a.onDrillToAttributeUrlError, 
    //
    onDrillToCustomUrl = _a.onDrillToCustomUrl, onDrillToCustomUrlSuccess = _a.onDrillToCustomUrlSuccess, onDrillToCustomUrlError = _a.onDrillToCustomUrlError, 
    //
    onDrillToLegacyDashboard = _a.onDrillToLegacyDashboard, onDrillToLegacyDashboardSuccess = _a.onDrillToLegacyDashboardSuccess, onDrillToLegacyDashboardError = _a.onDrillToLegacyDashboardError, 
    //
    onError = _a.onError;
    var drill = useDrill_1.useDrill({
        onBeforeRun: onDrill,
        onSuccess: onDrillSuccess,
        onError: onDrillError !== null && onDrillError !== void 0 ? onDrillError : onError,
    });
    var drillDown = useDrillDown_1.useDrillDown({
        onBeforeRun: onDrillDown,
        onSuccess: onDrillDownSuccess,
        onError: onDrillDownError !== null && onDrillDownError !== void 0 ? onDrillDownError : onError,
    });
    var drillToInsight = useDrillToInsight_1.useDrillToInsight({
        onBeforeRun: onDrillToInsight,
        onSuccess: onDrillToInsightSuccess,
        onError: onDrillToInsightError !== null && onDrillToInsightError !== void 0 ? onDrillToInsightError : onError,
    });
    var drillToDashboard = useDrillToDashboard_1.useDrillToDashboard({
        onBeforeRun: onDrillToDashboard,
        onSuccess: onDrillToDashboardSuccess,
        onError: onDrillToDashboardError !== null && onDrillToDashboardError !== void 0 ? onDrillToDashboardError : onError,
    });
    var drillToAttributeUrl = useDrillToAttributeUrl_1.useDrillToAttributeUrl({
        onBeforeRun: onDrillToAttributeUrl,
        onSuccess: onDrillToAttributeUrlSuccess,
        onError: onDrillToAttributeUrlError !== null && onDrillToAttributeUrlError !== void 0 ? onDrillToAttributeUrlError : onError,
    });
    var drillToCustomUrl = useDrillToCustomUrl_1.useDrillToCustomUrl({
        onBeforeRun: onDrillToCustomUrl,
        onSuccess: onDrillToCustomUrlSuccess,
        onError: onDrillToCustomUrlError !== null && onDrillToCustomUrlError !== void 0 ? onDrillToCustomUrlError : onError,
    });
    var drillToLegacyDashboard = useDrillToLegacyDashboard_1.useDrillToLegacyDashboard({
        onBeforeRun: onDrillToLegacyDashboard,
        onSuccess: onDrillToLegacyDashboardSuccess,
        onError: onDrillToLegacyDashboardError !== null && onDrillToLegacyDashboardError !== void 0 ? onDrillToLegacyDashboardError : onError,
    });
    return {
        drill: drill,
        drillDown: drillDown,
        drillToInsight: drillToInsight,
        drillToDashboard: drillToDashboard,
        drillToAttributeUrl: drillToAttributeUrl,
        drillToCustomUrl: drillToCustomUrl,
        drillToLegacyDashboard: drillToLegacyDashboard,
    };
}
exports.useDrills = useDrills;
//# sourceMappingURL=useDrills.js.map